{
  "settings": "Paramètres",
  "yourDigitalAssistant": "Votre assistant digital",
  "getStarted": "Commencer",
  "login": "S'identifier",
  "loggingIn": "Se connecter ...",
  "darkMode": "Mode sombre",
  "clearHistory": "Effacer l'historique",
  "historyCleared": "L'historique effacée",
  "changeLanguage": "Langue",
  "termsAndConditions": "Termes et conditions",
  "messagePlaceholder": "Tapez votre message ici ...",
  "messagePlaceholderDisabled": "Taper désactivé ...",
  "feedbackTitle": "Évaluer votre expérience",
  "feedbackPlaceholder": "Racontez-nous (en option)",
  "feedbackSend": "Envoyer",
  "feedbackClose": "Fermer",
  "sessionExpired": "Votre session a expiré en cause d'inactivité.",
  "startNewSession": "Commencer une nouvelle session",
  "apiError": "Oups! Quelque chose s'est mal passé. Nous travaillons à résoudre ce problème dès que possible.",
  "apiErrorOffline": "Vous n'êtes pas connecté à Internet.",
  "tryAgain": "Réessayer",
  "startOver": "Recommencer",
  "chatEnded": "Le chat est terminé.",
  "chatEndedThankYou": "Merci d'avoir discuté avec nous!",
  "closeChat": "Fermer",
  "startNewChat": "Chattez à nouveau",
  "humanTakeoverStarted": "Vous êtes maintenant transféré au service client ...",
  "humanTakeoverQueued": "En attente de connexion à un agent",
  "humanTakeoverAnAgent": "Un agent",
  "humanTakeoverAgentEntered": "est entré dans la conversation",
  "humanTakeoverAgentLogout": "quitté la conversation",
  "humanTakeoverTransfer": "Vous êtes transféré à un nouvel agent",
  "humanTakeoverEnded": "Vous discutez maintenant avec votre assistant digital",
  "version": "Version",
  "formIntroText": "Veuillez remplir le formulaire suivant pour commencer à discuter avec nous.",
  "formFirstName": "Prénom",
  "formLastName": "Nom",
  "formName": "Nom",
  "formEmail": "E-mail",
  "formWrongEmail": "Veuillez fournir une adresse e-mail valide.",
  "formPhone": "Téléphone",
  "formShipmentId": "ID de l'envoi",
  "formQuestion": "Votre question",
  "formAccountNumber": "Numéro de compte (pour les clients professionnels)",
  "formAddress": "Adresse",
  "formPostcode": "Code postal",
  "formCity": "Ville",
  "formCountry": "Pays",
  "formSubmitButton": "Démarrer le chat",
  "formEmptyFieldError": "Non autorisé à être vide.",
  "formPhoneNumberValidationError": "Ce n'est pas un numéro de téléphone valide.",
  "formInputIsBiggerThan50": "Doit contenir au plus 50 caractères.",
  "formInputIsBiggerThan100": "Doit contenir au plus 100 caractères.",
  "formInputIsBiggerThan2000": "Doit contenir au plus 2000 caractères.",
  "widgetEventOnline": "Message DA: l'utilisateur est de nouveau en ligne.",
  "widgetEventHidden": "Message DA: le widget est masqué.",
  "widgetEventVisible": "Message DA: le widget est visible.",
  "widgetEventVisibleMinimized": "Message DA: le widget est visible, mais réduit.",
  "widgetEventMinimized": "Message DA: le widget est réduit.",
  "widgetEventMaximized": "Message DA: Le widget est maximisé.",
  "widgetEventSessionExpired": "Message DA: la session du widget a expiré.",
  "widgetEventHangupHuman": "Message DA : Utilisateur mettant fin à la session de prise de contrôle humaine.",
  "widgetEventUserTyping": "Message DA: L'utilisateur est en train de taper.",
  "fileTooLarge": "Vous essayez de joindre des fichiers trop volumineux.",
  "tooManyDiles": "Vous essayez de joindre trop de fichiers.",
  "fileInvalidType": "Vous essayez de joindre des types de fichiers non valides.",
  "attachmentsDropHere": "Déposez ici pour télécharger ou",
  "attachmentsBrowse": "Parcourir les fichiers",
  "attachmentsExtenstionQuantity": "pdf ou images (jusqu'à 10 fichiers)",
  "attachmentsSize": "jusqu'à 30 Mo",
  "attachmentsFailedUploading": "Le téléchargement a échoué",
  "attachmentsUploading": "Téléchargement...",
  "minimizeExpandText": "Chattez en direct avec nous maintenant!",
  "popupWidgetNotificationMessage": "Vous avez reçu un nouveau message !",
  "tabWidgetNotificationMessage": "Nouveau message!",
  "datepickerSendButton": "Envoyer"
}
